import type { ColumnDef } from "@tanstack/react-table";
import Skeleton from "react-loading-skeleton";

export interface TableSkeletonProps<T> {
  rowCount: number;
  columnDefs: ColumnDef<T>[];
}

export function TableSkeleton<T>({
  rowCount,
  columnDefs,
}: TableSkeletonProps<T>) {
  const headerNames = columnDefs.map((col) => {
    if (typeof col.header === "string") {
      return col.header;
    }

    return col.id;
  });

  return (
    <div role="table" className="w-full rounded bg-white shadow-sm">
      <div
        className="grid auto-rows-[35px] min-w-full sticky top-0 bg-white z-50"
        style={{
          gridTemplateColumns: `repeat(${headerNames.length}, minmax(0, 1fr))`,
        }}
      >
        {headerNames.map((headerName, index) => (
          <div
            key={index}
            className={`flex items-center justify-center box-border cursor-grab px-3 py-1 border-1 bg-white
               text-sm font-semibold border-gray-200 shadow-xs}`}
          >
            {headerName}
          </div>
        ))}
      </div>

      {Array.from({ length: rowCount }).map((_, index) => (
        <div
          key={index}
          className={`grid auto-rows-[35px] min-w-full`}
          style={{
            gridTemplateColumns: `repeat(${headerNames.length}, minmax(0, 1fr))`,
          }}
        >
          {Array.from({ length: headerNames.length }).map((_, cellIndex) => (
            <Skeleton
              key={cellIndex}
              width={"100%"}
              height={35}
              borderRadius={0}
              className="flex box-border w-full bg-white border-r-1 border-r-gray-300 border-b-1 border-b-gray-300 transition skeleton-wave"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
